// Full-page navigation away from the portal SPA. A separate module so tests can observe it (jsdom cannot navigate).
// Callers must validate the destination first (see mcp-links.ts).
export const leavePortal = (url) => {
    window.location.assign(url);
};
